module.exports = __webpack_public_path__ + "media/images/emoticons/cafe-b2739e09e24456eededfc228e5978623.gif";